import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";
import SwipeableTextMobileStepper from "./MobileStepper";

import { SecondaryStyle } from "../fonts";

import Carousel1Image1 from "../assets/Page3LB1.webp";
import Carousel1Image2 from "../assets/Page3LB2.webp";
import Carousel1Image3 from "../assets/Page3LB3.webp";
import RB from "../assets/Page3RB.webp";
import RA from "../assets/Page3RA.webp";
import LD from "../assets/Page3LD.webp";

//@ts-ignore
import LC from "../assets/Page3LC.mp4";
//@ts-ignore
import RD from "../assets/Page3RD.mp4";

const carousel1Images = [Carousel1Image1, Carousel1Image2, Carousel1Image3];

const Page3 = (props) => {
  const { checked, isReverse } = props;

  return (
    <Slide
      direction={isReverse ? "right" : "left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          width: "100vw",
          height: { xs: "100%", sm: "100vh" },
          overflow: { xs: "auto", sm: "hidden" },
        }}
      >
        <Grid container sx={{ height: "100%" }} id="scrollTarget">
          {/* First Half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: { xs: "100%", sm: "50vh" },
                    width: "100%",
                  }}
                >
                  {/* LD/*/}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      height: { xs: "45vh", sm: "100%" },
                      backgroundImage: `url('${LD}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      borderBottom: ".5vh solid #fff",
                      borderTop: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },

                      borderRadius: { xs: "16px", sm: "0vh" },
                    }}
                  />
                  {/**LA */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderTop: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "none",
                        sm: ".5vh solid #fff",
                      },
                      paddingBottom: { xs: 1, sm: 0 },
                      px: { xs: 1.5, md: 1.5, lg: 2, xl: 3 },
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        ...SecondaryStyle,

                        textAlign: { xs: "justify", sm: "right" },
                        "@media (orientation: landscape)": {
                          fontSize: { xs: "1vw", md: "1vw", lg: "1vw" },
                          lineHeight: {
                            xs: "1.5vw",
                            md: "1.5vw",
                            lg: "1.5vw",
                          },
                        },
                        "@media (orientation: portrait)": {
                          fontSize: { xs: "1.7vh", sm: "1vh" },
                          lineHeight: {
                            xs: "2vh",
                            sm: "1.5vh",
                            md: "1.5vh",
                            lg: "1.5vh",
                          },
                          paddingTop: {
                            xs: "0vh",
                            sm: "2vh",
                            md: "2vh",
                            lg: "2vh",
                          },
                        },
                      }}
                    >
                      The second-floor primary bedroom offers a refined retreat,
                      bathed in natural light and featuring sophisticated
                      finishes. The spacious bedroom is designed for comfort,
                      providing a peaceful atmosphere ideal for restful nights.
                      Complementing the bedroom is a luxurious 5-piece bathroom,
                      complete with a deep soaking tub, separate glass-enclosed
                      shower, and double sinks. This suite provides a sanctuary
                      within the home, combining style and practicality
                      seamlessly.
                    </Typography>
                  </Grid>
                  {/* LC*/}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderTop: {
                        xs: ".5vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      display: "flex",

                      alignItems: "center",
                      height: {
                        xs: "45vh",
                        sm: "100%",
                      },
                    }}
                  >
                    <CardMedia
                      component={"video"}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        height: {
                          xs: "45vh",
                          sm: "100%",
                        },
                        objectFit: "cover",
                      }}
                      src={LC}
                      autoPlay
                      muted
                      loop
                      playsInline
                    />
                  </Grid>

                  {/**LB */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderTop: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      height: {
                        xs: "35.5vh",
                        sm: "100%",
                      },
                    }}
                  >
                    <SwipeableTextMobileStepper
                      images={carousel1Images}
                      showArrows={true}
                      showDots={true}
                      autoplay={false}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* 2nd half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: "100%",
                  }}
                >
                  {/* RC */}

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderTop: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },

                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      height: {
                        xs: "46vh",
                        sm: "50vh",
                      },
                      borderRadius: { xs: "16px", sm: "0vh" },
                    }}
                  >
                    <CardMedia
                      component={"video"}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        height: {
                          xs: "45vh",
                          sm: "100%",
                        },
                        objectFit: "cover",
                      }}
                      src={RD}
                      autoPlay
                      muted
                      loop
                      playsInline
                    />
                  </Grid>

                  {/**RB */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      backgroundImage: `url('${RA}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      borderBottom: ".5vh solid #fff",
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderTop: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      height: { xs: "45vh", sm: "50vh" },
                    }}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: "100%",
                  }}
                >
                  {/* RD/RA */}
                  <Grid
                    item
                    xs={12}
                    sx={{
                      borderTop: {
                        xs: ".5vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      backgroundImage: `url('${RB}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderBottom: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderRadius: { xs: "16px", sm: "0vh" },
                      height: {
                        xs: "45.5vh",
                        sm: "100%",
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Page3;
